import React, { useState } from 'react'
import { PhysicsSurvivalRunner } from '../components/game/PhysicsSurvivalRunner'
import { useNavigate } from 'react-router-dom'
import { Home, Volume2, VolumeX } from 'lucide-react'

/**
 * Page test riêng để chạy Physics Survival Runner game độc lập
 * URL: /test-physics-survival-runner
 */
const TestPhysicsSurvivalRunner: React.FC = () => {
  const navigate = useNavigate()
  const [musicControls, setMusicControls] = useState<{ toggle: () => void; isPlaying: boolean } | null>(null)

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black relative">
      {/* Header test - Đặt bên trái không chồng */}
      <div className="absolute top-12 left-2 z-[100] flex flex-col gap-2">
        <button
          onClick={() => navigate('/')}
          className="bg-purple-600/90 hover:bg-purple-700 text-white px-3 py-1.5 rounded-lg flex items-center gap-2 backdrop-blur-sm transition-all text-sm shadow-lg"
        >
          <Home size={16} />
          <span className="hidden md:inline">Home</span>
        </button>
        <button
          onClick={() => window.location.reload()}
          className="bg-purple-600/90 hover:bg-purple-700 text-white px-3 py-1.5 rounded-lg backdrop-blur-sm transition-all text-sm shadow-lg"
        >
          🔄 <span className="hidden md:inline">Reload</span>
        </button>
        
        {/* Nút tắt/bật nhạc */}
        {musicControls && (
          <button
            onClick={musicControls.toggle}
            className={`px-3 py-1.5 rounded-lg backdrop-blur-sm transition-all text-sm shadow-lg flex items-center gap-2 ${
              musicControls.isPlaying
                ? 'bg-purple-600/90 hover:bg-purple-700 text-white'
                : 'bg-gray-600/90 hover:bg-gray-700 text-white/70'
            }`}
            title={musicControls.isPlaying ? 'Tắt nhạc' : 'Bật nhạc'}
          >
            {musicControls.isPlaying ? <Volume2 size={16} /> : <VolumeX size={16} />}
            <span className="hidden md:inline">{musicControls.isPlaying ? 'Nhạc' : 'Nhạc'}</span>
          </button>
        )}
      </div>

      {/* Info panel - Đặt bên phải không chồng */}
      <div className="absolute top-12 right-2 z-[100] bg-purple-600/90 backdrop-blur-sm text-white px-3 py-1.5 rounded-lg text-xs shadow-lg">
        <p>🧪 Test: Physics Survival Runner</p>
        <p className="text-[10px] opacity-75">Bài 1 L11</p>
      </div>

      {/* Game */}
      <PhysicsSurvivalRunner
        lop={11}
        chuong={1}
        bai={1}
        minQuestions={6}
        maxQuestions={10}
        onExit={() => {
          console.log('Game exit called')
          navigate('/')
        }}
        onMusicControlsReady={(controls) => setMusicControls(controls)}
      />
    </div>
  )
}

export default TestPhysicsSurvivalRunner

